import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CurrencyContext } from "./CurrencyContext";

export const CurrencyProvider = ({ children }) => {
  const getDefaultCurrency = () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone === "Asia/Kolkata" || timeZone === "Asia/Calcutta"
      ? "INR"
      : "USD";
  };

  const [currency, setCurrency] = useState(() => {
    const storedCurrency = localStorage.getItem("currency");
    if (storedCurrency === "INR" || storedCurrency === "USD") {
      return storedCurrency;
    }

    const defaultCurrency = getDefaultCurrency();
    localStorage.setItem("currency", defaultCurrency);
    return defaultCurrency;
  });

  useEffect(() => {
    localStorage.setItem("currency", currency);
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

CurrencyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CurrencyProvider;
